import { Modal } from "./Modal";
import { observer } from "mobx-react-lite";
import { useTranslation } from "src/translations";

interface OverrideCanvasDesignModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onContinue: () => Promise<void>;
  designName: string;
}

export const OverrideCanvasDesignModal = observer((props: OverrideCanvasDesignModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal.Portal isOpen={props.isOpen}>
      <Modal.Card onClose={props.onCancel}>
        <Modal.Header label={t("overrideCanvas.title")} onClose={props.onCancel} />
        <div className="max-w-[428px]">
          {t("overrideCanvas.message", { name: props.designName })}
        </div>
        <Modal.Actions>
          <Modal.ActionCancelButton onClick={props.onCancel} label={t("common.cancel")} />
          <Modal.ActionPrimaryButton onClick={props.onContinue} label={t("common.continue")} />
        </Modal.Actions>
      </Modal.Card>
    </Modal.Portal>
  );
});
